<template>
  <b-container fluid>
    <b-row class="mb-2">
      <b-col class="px-sm-3 px-0">
        <h1>Brands</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="px-sm-3 px-0">
        <b-overlay :show="loading" no-wrap fixed />
        <b-form inline class="mb-2" @submit.prevent="applyFilters">
          <b-form-input
            v-model="queryFilters.search"
            placeholder="Search by name or id"
            title="Search by name or id"
            class="mr-2 mb-2 single-input"
          />
          <custom-search-field
            v-if="hubCount > 1"
            v-model="queryFilters.hub"
            class="mr-2 mb-2 single-input"
            :placeholder="'Filter by hub'"
            :path-to-search="'facilities'"
          />
          <custom-search-field
            v-if="kitchenCount > 1"
            v-model="queryFilters.kitchen"
            class="mr-2 mb-2 single-input"
            :placeholder="'Filter by kitchen'"
            :path-to-search="'fulfillment-centers'"
          />
          <custom-search-field
            v-model="queryFilters.menu"
            class="mr-2 mb-2 single-input"
            :placeholder="'Filter by menu'"
            :path-to-search="'menus'"
            :query-params="{
              status: 'active,inactive',
            }"
          />
          <b-form-group class="custom-search-input mr-2 mb-2">
            <multiselect
              v-model="queryFilters.status"
              select-label=""
              open-direction="bottom"
              :options="statusOptions"
              track-by="value"
              deselect-label="remove"
              :searchable="false"
              :close-on-select="true"
              :show-no-results="false"
              :hide-selected="false"
              label="name"
              placeholder="Filter by status"
              class="single-input"
            />
          </b-form-group>
          <b-button type="submit" variant="primary" class="mr-2 mb-2"
            >Filter</b-button
          >
        </b-form>
      </b-col>
    </b-row>
    <b-row class="overflow-auto">
      <b-col class="px-sm-3 px-0">
        <b-table
          hover
          no-local-sorting
          small
          :fields="fields"
          :items="data"
          :busy="busy"
          @sort-changed="onSortingChanged"
          @row-clicked="onRowClicked"
        >
          <template #cell(name)="row">
            <router-link :to="`/brands/${row.item.id}`">
              {{ row.item.name }}
            </router-link>
          </template>
          <template #cell(status)="row">
            {{ row.item.status | capitalize }}
          </template>
          <template #cell(hub)="row">
            <span v-for="(hub, index) in row.item.facilities" :key="hub.id">
              {{ hub.name
              }}<template v-if="index !== row.item.facilities.length - 1"
                >,</template
              >
            </span>
          </template>
          <template #cell(kitchens)="row">
            <span
              v-for="(kitchen, index) in row.item.fulfillment_centers"
              :key="kitchen.id"
            >
              {{ kitchen.name }} (#{{ kitchen.id }})<template
                v-if="index !== row.item.fulfillment_centers.length - 1"
                >,</template
              >
            </span>
          </template>
          <template #cell(menus)="row">
            {{ row.item.menus.length }}
          </template>
        </b-table>
      </b-col>
    </b-row>
    <pagination-handler v-if="data.length" :query-data="queryFilters" />
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import tableMixin from '../../mixins/TableMixin';
import ResourceAPI from '../../services/ResourceAPI';

export default {
  name: 'Brands',
  mixins: [tableMixin],
  data() {
    return {
      statusOptions: [
        {
          value: 'active',
          name: 'Active',
        },
        {
          value: 'inactive',
          name: 'Inactive',
        },
      ],
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Brand',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'hub',
          label: 'Hubs',
          sortable: false,
        },
        {
          key: 'kitchens',
          label: 'Kitchens',
          sortable: false,
        },
        {
          key: 'menus',
          label: '# Menus',
          sortable: true,
        },
      ],
      rowRouteName: 'brand',
      data: [],
      loading: false,
      exportAlert: false,
    };
  },
  computed: {
    ...mapGetters('session', ['brandAdmin', 'kitchenCount', 'hubCount']),
  },
  watch: {
    hubCount(val) {
      if (val === 1) {
        this.removeTableColumn('hub');
      }
    },
    kitchenCount(val) {
      if (val === 1) {
        this.removeTableColumn('kitchens');
      }
    },
  },
  mounted() {
    if (this.hubCount === 1) {
      this.removeTableColumn('hub');
    }

    if (this.kitchenCount === 1) {
      this.removeTableColumn('kitchens');
    }
  },
  methods: {
    loadResults() {
      this.setRequestData();

      // Format search params for query
      const searchParams = { ...this.queryFilters };
      searchParams.fulfillmentCenter = searchParams.kitchen
        ? searchParams.kitchen.id
        : null;
      searchParams.facility = searchParams.hub ? searchParams.hub.id : null;
      searchParams.menu = searchParams.menu ? searchParams.menu.id : null;
      searchParams.status = searchParams.status
        ? searchParams.status.value
        : 'active,inactive';
      searchParams.with = 'menus,fulfillmentCenters';
      searchParams.appends = 'facilities';

      return ResourceAPI.getRecords('brands', searchParams)
        .then((data) => {
          this.setResponseData(data);
        })
        .catch((error) => alert(error));
    },
  },
};
</script>
